export default "__VITE_ASSET__DrurYr_w__"